import { useQuery } from '@apollo/client';
import { ListSubprojectMetadataDocument } from '~/gql/ucpw/graphql';
import { safelyParseJson } from '~/utils';
import { useProjectIds } from './useProjectIds';

export const useSubProjectMetadata = () => {
    const projectIds = useProjectIds();
    const response = useQuery(ListSubprojectMetadataDocument, {
        variables: { id: projectIds.projectId as number },
        context: { clientName: 'ucpw' },
        skip: !projectIds.projectId,
        fetchPolicy: 'network-only',
    });
    const project = response?.data?.item?.item;
    const subproject = project?.subprojekt || [];

    const projectMetadata = safelyParseJson(project?.metadata) || {};
    const subprojectMetadata = subproject.map(
        (subproject) => safelyParseJson(subproject?.metadata) || {}
    );

    const data = {
        projectMetadata,
        subprojectMetadata,
        hasServiceRequestId:
            projectMetadata?.hasOwnProperty('serviceRequestId') ||
            subprojectMetadata.some((subproject) => subproject?.hasOwnProperty('serviceRequestId')),
    };

    return data;
};
